module.exports = "/activationc564398b4ad19244cddce3586f466095.png";